import { motion } from "framer-motion"
import styles from './Questions.module.scss'
import Hint from '../../components/Hint/Hint'
import {phone} from '../../utils/data'

const titleAnimation = {
    hidden: {
        y: 100,
        opacity: 0,
    },

    visible: {
        y: 0,
        opacity: 1,
        transition: { duration: .3 }
    }
}

const boxAnimation = {
    hidden: {
        y: 100,
        opacity: 0,
    },
    visible: {
        y: 0,
        opacity: 1,
        transition: { duration: .4}
    } 
}


const Questions = () => {

    return (
        <motion.section
            id='voprosy-i-otvety'
            className={styles.main}
            initial='hidden'
            whileInView='visible'
            viewport={{amount: 0.1, once: true}}
            >
                    <div className={styles.box}>
                        <div className={styles.container}>
                            <motion.h2 className={styles.title} variants={titleAnimation}>Отвечаем на частые вопросы о ВКС</motion.h2>
                            <motion.div className={styles.box_list} variants={boxAnimation}>
                            <ul className={styles.list} >
                                <Hint
                                        question='Что входит в услугу?'
                                    >
                                    <p className={styles.text}> <span>&#183;</span> Консультация</p>
                                    <p className={styles.text}><span>&#183;</span> Нотариальный перевод паспорта</p>
                                    <p className={styles.text}><span>&#183;</span> Оформление разрешения на работу</p>
                                    <p className={styles.text}><span>&#183;</span> Государственная пошлина в размере 4 200₽ оплачивается клиентом самостоятельно.</p>
                                </Hint>
                                <Hint
                                        question='Кто такие ВКС?'
                                    >
                                    <p className={styles.text}>ВКС — высококвалифицированные иностранные специалисты с опытом работы в определенной сфере, привлекаемые к работе в РФ и получающие вознаграждение в размере от 83 500 руб./мес. Они могут быть научными сотрудниками, преподавателями, работать в особых экономических зонах или на конкретных предприятиях. Они получают разрешение на работу и рабочую визу на три года с возможностью пребывания в стране в течение всего срока.</p>
                                </Hint>
                                <Hint
                                        question='Кто может привлекать ВКС?'
                                    >
                                    <p className={styles.text}>ВКС могут работать в научных, образовательных, медицинских, коммерческих и некоторых некоммерческих организациях.</p>
                                </Hint>
                                <Hint
                                        question='Кто не может привлекать ВКС?'
                                    >
                                    <p className={styles.text}>ВКС не могут работать на государственной службе, на военных судах, быть командирами гражданских самолетов, работать на объектах безопасности, заниматься религиозной деятельностью и работать в розничной торговле.</p>
                                </Hint>
                                <Hint
                                        question='Налогообложение ВКС'
                                    >
                                    <p className={styles.text}>ВКС облагаются НДФЛ по ставке 13%, и не платят дополнительные взносы; в пенсионный фонд, в фонд обязательного медицинского страхования и соцстрах. Однако работодатель начисляет взносы на травматизм.</p>
                                </Hint>
                                <Hint
                                        question='Особые условия для ВКС'
                                    >
                                    <p className={styles.text}>ВКС в России имеют особые условия: могут не регистрироваться в течение 90 дней, могут трудоустроиться в другую компанию в течение 30 дней после расторжения контракта. Необходимо получить разрешение на работу в течение 30 дней после принятия решения.</p>
                                </Hint>
                                <Hint
                                        question='Какие гарантии того, что я получу разрешение на работу?'
                                    >
                                    <p className={styles.text}>Наша компания уже более 10 лет работает в России в сфере миграционных услуг, что гарантирует высокий уровень оказываемых нами услуг. Мы предлагаем широкий спектр услуг в сфере миграционного законодательства. Наши специалисты окажут Вам полную юридическую поддержку, связанную с оформлением разрешений на работу для иностранных граждан. Накопленный нами опыт за долгие годы работы в сфере миграционного законодательства позволяет нам решать самые сложные задачи и гарантировать результат.</p>
                                </Hint>
                                <Hint
                                        question='Могу ли я подать документы на разрешение на работу самостоятельно?'
                                    >
                                    <p className={styles.text}>Нет, вы не можете подавать документы на разрешение на работу самостоятельно. Документы подаются только от юридического лица, которое готово принять вас на работу и заключить с вами трудовой договор.</p>
                                </Hint>
                                <Hint
                                        question='Сколько стоят ваши услуги?'
                                    >
                                    <p className={styles.text}>Стоимость наших услуг зависит от сложности вашего кейса и объема необходимых миграционных услуг. Мы предоставляем прозрачную и конкурентоспособную ценовую политику, а индивидуальные условия обсуждаются отдельно.</p>
                                </Hint>
                                <Hint
                                        question='Привлекательность для работодателя'
                                    >
                                    <p className={styles.text}>ВКС — высококвалифицированные специалисты с преимуществами при трудоустройстве в России. Работодателям выгодно нанимать их, так как это упрощает процесс найма, экономит время и позволяет нанимать больше сотрудников без учета квот. Зарплата ВКС в коммерческих организациях должна быть не менее 250 000 рублей в месяц. Преимущества трудоустройства ВКС включают отсутствие квот, разрешений на привлечение иностранной рабочей силы и более низкую ставку НДФЛ.</p>
                                </Hint>
                                </ul>
                            </motion.div>
                            <a className={styles.button} target='_blank' rel='noopener noreferrer' href={'https://t.me/' + phone} aria-label='связаться вацап'>
                                <span>Задать свой вопрос в Telegram</span>
                                <svg id="Layer_1" enable-background="new 0 0 152 152" viewBox="0 0 152 152" xmlns="http://www.w3.org/2000/svg"><path id="Icon" d="m137.7 17.2-125.3 54.1c-1.2.5-1.8 1.9-1.2 3.1.2.5.5.9 1 1.1l29.2 17.2c.3.2.6.5.7.9l13.4 39.8c.4 1.2 1.8 1.9 3 1.5.4-.1.7-.3 1-.6l17.5-18.7c.5-.5 1.3-.6 1.9-.3l22.5 12.3c1.1.6 2.6.2 3.2-.9.1-.1.1-.3.2-.4l36.1-106.1c.4-1.2-.2-2.6-1.5-3-.6-.2-1.2-.2-1.7 0zm-73.4 85.6-6.5 18.2-9.4-28.7 68.4-52.1z"/></svg>
                            </a>
                        </div>
                    </div>
        </motion.section>
        
    )
}

export default Questions